import DynamicBreadcrumb from "../Components/Breadcrumbs";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import "./Styles/ViewJob.css";
import JobTitle from "../Components/JobTitle";
import JobFilters from "../Components/JobFilters";
import Users from "../../../asset/svgs/Users";
import HourGlass from "../../../asset/svgs/HourGlass";
import ApplicantsTable from "../Components/JobTable";
import {
  useDeleteJobPost,
  useGetJobApplicantByJobId,
  useGetJobPostDetail,
} from "../hooks/useJobs";
import { NeonHexagonLoader } from "../Components/JobLoader";
import { calculateExpiry } from "../helper";
import { message, Modal, Spin } from "antd";
import Delete from "../../../asset/svgs/Delete";

const ViewJobs = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [jobEdit, setJobEdit] = useState(false);
  const [currentPage, setCurrentPage] = useState(1); // Track the current page
  const [pageSize] = useState(10);
  const {
    getJobPostDetail,
    loading,
    data: jobsDetails,
  } = useGetJobPostDetail();
  const { deleteJobPost, loading: deletingJob } = useDeleteJobPost();

  const userId = localStorage.getItem("jobUserId");
  useEffect(() => {
    const fetchJobsDetail = async () => {
      await getJobPostDetail(id, { user_id: userId });
    };

    fetchJobsDetail();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getJobPostDetail, userId]);

  const {
    getJobPostApplicants,
    loading: appsDataLoading,
    data: jobsApplicantsList,
  } = useGetJobApplicantByJobId();

  useEffect(() => {
    const fetchJobsApplicant = async () => {
      await getJobPostApplicants(id, { user_id: userId, page: currentPage });
    };

    fetchJobsApplicant();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getJobPostApplicants, userId]);

  console.log("Table Data:", jobsApplicantsList);
  const activeDays = calculateExpiry(jobsDetails?.expiration_date);
  const pagination = {
    current: currentPage,
    pageSize: pageSize,
    total: jobsApplicantsList?.length,
    onChange: (page) => {
      setCurrentPage(page); // Update current page
    },
    showSizeChanger: false, // Optional: hide page size changer dropdown
    showQuickJumper: true, // Optional: allow quick jumping to a page
  };
  const handleEditNavigation = () => {
    setJobEdit(true);
  };
  useEffect(() => {
    if (jobEdit && jobsDetails && jobsDetails.id) {
      console.log("🔍 Navigating with jobsDetails:", jobsDetails);

      const normalizedJobData = {
        id: jobsDetails.id,
        basics: {
          title: jobsDetails.title,
          location: jobsDetails.location,
          job_type: jobsDetails.job_type,
          category: jobsDetails.category,
          expirationDate: jobsDetails.expiration_date,
        },
        compensation: {
          minimum: jobsDetails.minimum,
          maximum: jobsDetails.maximum,
          currency: jobsDetails.currency,
          salary_date: jobsDetails.salary_date,
        },
        description: jobsDetails.description,
        media: {
          image: jobsDetails.image,
        },
      };

      navigate("/jobs/job-admin/job-posts/create-job", {
        state: {
          jobEdit: true,
          jobData: normalizedJobData,
        },
      });
    }
  }, [jobsDetails, jobEdit, navigate]);
  const handleDeleteJob = (jobId) => {
    Modal.confirm({
      title: "Delete this job?",
      content:
        "Are you sure you want to delete this job? This action cannot be undone.",
      okText: "Yes, delete",
      okType: "danger",
      cancelText: "No, keep it",
      onOk: async () => {
        try {
          await deleteJobPost({
            user_id: userId,
            id: jobId,
          });
          message.success("Job deleted successfully");
          navigate(-1);
        } catch (err) {
          message.error("Failed to delete job. Please try again.");
        }
      },
    });
  };
  if (loading)
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <NeonHexagonLoader />
      </div>
    );
  return (
    <div className="view-jobs-container">
      <nav>
        <DynamicBreadcrumb jobTitle={jobsDetails?.title} />
        <div className="view-jobs-nav-buttons">
          <button onClick={handleEditNavigation} className="edit">
            Edit Job
          </button>
          <button
            onClick={() => handleDeleteJob(jobsDetails?.id)}
            className="delete"
            title="Delete Job"
          >
            {deletingJob ? <Spin /> : <Delete size={16} />}
          </button>
        </div>
      </nav>

      <div className="view-jobs-header">
        <div>
          <JobTitle jobData={jobsDetails} />
          <JobFilters jobData={jobsDetails} />
        </div>
        <div className="view-jobs-cards">
          <div className="stat-card">
            <h3>New</h3>
            <div className="stat-card-content">
              <p>{jobsDetails?.applicants || 0}</p>
              <Users />
            </div>
          </div>
          <div className="stat-card">
            <h3>To Review</h3>
            <div className="stat-card-content">
              <p>{jobsDetails?.applications || "N/A"}</p>
              <span style={{ color: "#727272", fontSize: "0.77275rem" }}>
                to Review
              </span>
            </div>
          </div>
          <div className="stat-card">
            <h3>Days Active</h3>
            <div className="stat-card-content">
              <p>{activeDays || "N/A"}</p>
              <HourGlass />
            </div>
          </div>
        </div>
      </div>
      {/* Job description */}
      <div className="view-jobs-description">
        <h2>Job Description</h2>
        <div className="view-job-description-content">
          <p>
            <div
              dangerouslySetInnerHTML={{ __html: jobsDetails?.description }}
            />
          </p>
        </div>
      </div>
      {/* Job Application table */}
      <div className="view-job-table">
        <ApplicantsTable
          jobData={jobsApplicantsList}
          appDataloading={appsDataLoading}
          pagination={pagination}
        />
      </div>
    </div>
  );
};
export default ViewJobs;
